import { Box, Grid, Typography } from '@mui/material';
import React from 'react';

import CardSummary from './CardSummary';

interface ProductSummaryProps {
  data?: {
    payDaysAverage?: number;
    operationDatePayDaysAverage?: number;
    documentsTotal?: number;
    documentsPaid?: number;
    amountTotal?: number;
    amountPaid?: number;
    businessIdentifiersUniqueQuantity?: number;
  };
  productName: string;
}

const ProductSummary = (props: ProductSummaryProps) => {
  const { data, productName } = props;
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 3 }}>
        {productName}
      </Typography>

      <Grid container spacing={3}>
        {productName != 'Créditos' && (
          <>
            <CardSummary
              bottomText="Promedio de pago (días desde F.E.)"
              value={data?.payDaysAverage ?? 0}
            />

            <CardSummary
              bottomText="Promedio de pago (días desde F.O.)"
              value={data?.operationDatePayDaysAverage ?? 0}
            />

            <CardSummary
              bottomText="Promedio por documento"
              value={`$${data?.documentsTotal && data?.amountTotal ? parseFloat((data.amountTotal / data.documentsTotal).toFixed(0)).toLocaleString() : 0}`}
            />
          </>
        )}

        <CardSummary
          bottomText="Total de documentos"
          value={data?.documentsTotal ?? 0}
        />

        <CardSummary
          bottomText="Documentos pagados"
          value={data?.documentsPaid ?? 0}
        />

        <CardSummary
          bottomText="Documentos pendientes"
          value={(data?.documentsTotal ?? 0) - (data?.documentsPaid ?? 0)}
        />

        <CardSummary
          bottomText="Monto total"
          value={`$${data?.amountTotal?.toLocaleString() ?? 0}`}
        />

        <CardSummary
          bottomText="Monto pagado"
          value={`$${data?.amountPaid?.toLocaleString() ?? 0}`}
        />

        <CardSummary
          bottomText="Monto pendiente"
          value={`$${((data?.amountTotal ?? 0) - (data?.amountPaid ?? 0)).toLocaleString()}`}
        />

        {productName != 'Créditos' && (
          <CardSummary
            bottomText="Clientes con los que ha operado"
            value={data?.businessIdentifiersUniqueQuantity ?? 0}
          />
        )}
      </Grid>
    </Box>
  );
};

export default ProductSummary;
